export default {
    layout: {
        zh: '简体中文',
        zhTw: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
        copyAddress: 'アドレスをコピー',
        switchWallet: 'ウォレット切替',
        disconnect: '切断',
        copied: 'コピーしました',
        failed:'failed',
        success:'success',
    },
    node: {
        progress: '処理中',
        executionSuccessful: '成功',
        at: '',
        view: '確認',
    },
    menu: {
        home: 'ホーム',
        exchange: '交換',
        mining: 'マイニング',
        assets: '資産',
        earnings: '収益',
        me: 'マイ',
        notice: 'お知らせ',
    },
    exchange: {
        title: '交換',
        send: '送信',
        receive: '受信',
        obtain: '獲得',
        consume: '消費',
        balance: '残高',
        max: '最大',
        currentPrice: '現在価格',
        submit: '交換',
        records: '交換履歴',
        price: '価格',
        success: '成功',
        fail: '失敗',
    },
    home: {
        brand: 'OnOx',
        slogan: '世界をつなぎ、未来を拓く',
        sloganDesc: '分散型・オープン・高効率',
        yield: '利回り',
        notice: 'お知らせ1、ABCマイニング開始',
        todayOutput: '本日のプール産出',
        networkHashrate: 'ネットワーク有効ハッシュレート',
        price: '現在価格',
        burned: '総バーン量',
 aboutTitle: '$DOLデフレ戦略エンジン',
aboutDesc: '6つのバーン（焼却）メカニズムが、$DOLトークンの価値を継続的に押し上げます',
featureHashrate: '$DOLのバーンでハッシュレートを獲得',
featureHashrateDesc: '自身のハッシュレートとチームのハッシュレート、双方から無限のブースト効果を得られます',
featureDaily: '毎日の収益精算',
featureDailyDesc: '有効ハッシュレートに基づいて算出され、収益履歴は明確に記録・追跡可能です',
featureSecurity: 'ハッシュレートの段階的増加',
featureSecurityDesc: '新規入金によって獲得できるハッシュレートの基準が、段階的に引き上げられていきます',
        bindTitle: '招待アドレスを紐付け',
        bindConfirm: '確認',
        bindPlaceholder: '0x000000000000000000000000000000',
        h11:'火牛憲章',
        h12:'DolphFiエコシステム 初のDAPP',
        h21:'火牛憲章',
        h22:'未来を燃え上がらせる',
        h31:'OnOx',
        h32:'炎と共に強気相場を牽引',
    },
    mining: {
        title: 'バーンマイニング',
        subtitle: 'ハッシュレートを有効化し収益を共有',
        totalT: '合計 (T)',
        shareT: 'シェア',
        teamT: 'チーム',
        burnT: 'バーン',
        validBurnT: '有効バーン',
        renew: '更新',
        amountPlaceholder: 'バーン数量を入力',
        token: 'バーン通貨',
        rate: 'リアルタイム換算',
        balance: 'ウォレット残高',
        submit: 'バーンマイニングに参加',
        hint: '実際に',
        burnLog: 'バーン記録',
        shareLog: 'シェア',
        renewLog: '更新記録',
        success: '成功',
        fail: '失敗',
        qty: '数量',
        hashrateT: 'ハッシュレート (T)',
        renewHashrate: '更新ハッシュレート',
        renewFee: '更新費用',
        renewDate: 'ハッシュレート期間',
        renewConvert: '換算数量',
        renewNote: '説明',
        renewNoteText: '2026.10.1までに更新してください。期限を過ぎるとマイニング収益を得られません。',
        renewConfirm: '更新を確認',
        ext1:'報酬ハッシュレート',
        ext2:'マイニング収益',
        ext3:'契約更新金額',
        rechargeTip: '初めてのご利用ですか？まずは DOL または USDT をチャージしてください',
        goRecharge: 'チャージする',
        renewdo:'更新済み',
    },
    earnings: {
        balance: '資産残高',
        recharge: '入金',
        withdraw: '出金',
        totalWithdraw: '累計出金',
        totalIncome: '総収益',
        mineIncome: 'マイニング収益',
        referral: '紹介報酬',
        incomeLog: '収益記録',
        rechargeLog: '入金記録',
        withdrawLog: '出金記録',
        qty: '数量',
        success: '成功',
        pending: '振込待ち',
        fail: '失敗',
        rechargeQty: '入金数量',
        withdrawQty: '出金数量',
        receiveQty: '着金数量',
        rechargeTitle: '入金',
        withdrawTitle: '出金',
        rechargeMin: '10未満不可',
        minAmount: '100未満不可',
        toAccount: '着金予定',
        fee: '手数料',
        rechargeAddress: '入金アドレス',
        address: '出金アドレス',
        confirmRecharge: '入金を確認',
        confirmWithdraw: '出金を確認',
        l1:'채굴 수익',
l1:'マイニング収益',
l2:'直接紹介報酬',
l3:'間接紹介報酬'
    },
    me: {
        inviteLink: '招待リンク',
        upline: '上位アドレス',
        inviteCount: '招待人数',
        teamCount: 'チーム人数',
        bigArea: '大エリア (T)',
        smallArea: '小エリアバーン (T)',
        team: 'チームメンバー',
        direct: '直接',
        indirect: '間接',
        umbrella: '傘下',
        burnT: 'バーン (T)',
        personT: '個人 (T)',
        teamBurn: 'チームバーン (T)',
        teamHash: 'チームハッシュレート (T)',
        remark: 'メモ',
        setRemark: 'メモ設定',
        remarkPlaceholder: 'メモを入力',
        confirm: '確認',
    },
    notice: {
        title: 'お知らせ詳細',
        headline: '見出し見出し見出し見出し',
        date: '2024-12-22',
        body: 'ユーザー各位\n\nXXXAppは2024年11月26日20時に正式リリースします。',
    },
};
